angular.module('zc.zenclerkS')
  .factory('ZcsCampaignElementCreator', ZcsCampaignElementCreator);

ZcsCampaignElementCreator.$inject = ['$filter', 'Template', 'currencies'];
function ZcsCampaignElementCreator($filter, Template, currencies) {
  const service = {
    createCampaignElement,
    getSelectableTemplates,
    setDefaultMessageValues,
  };

  const defaultMessage = {
    base_color: '#F1B33B',
    limit: '61',
    badge_position: 'left_bottom',
    badge_vertical_position: 10,
    badge_horizontal_position: 10,
    btntext_offer: $filter('translate')('services.campaignElementCreator.continueShopping'),
    btntext_present: 'OK',
    present_pagetype: 'cart',
    offer_hint: $filter('translate')('services.campaignElementCreator.clickToRedisplay'),
  };

  const basicSelectableTemplates = [
    {
      template_type: 'giftcard',
      label: $filter('translate')('services.campaignElementCreator.modernTemplate'),
      img_url: '/assets/img/icon-lg-coupon-giftcard.svg',
      release_date: new Date('2016-08-17'),
      presets: [
        {
          name: 'default',
          label: $filter('translate')('services.campaignElementCreator.default'),
          template_type: 'giftcard',
          img_url: '',
          element: _.merge(defaultMessage, {
            // Allowed properties:
            // ==================
            // show_modal_first
            // logo
            // discount_type
            // discount_value
            // limit
            // base_color
            // show_incentive_text
            // badge_position
            // coupon_pattern
            // code_condition
            // code_description
            // preset_pagetype
            // reject_pagetypes
            // receive_page_types
            // ignore_pagetype

            base_color: '#F76065',
            badge_position: 'zc-badge-right',
          })
        }
      ]
    },

    {
      template_type: 'zcs_textonly',
      label: $filter('translate')('services.campaignElementCreator.textTemplate'),
      img_url: '/assets/img/icon-lg-coupon-color.svg',
      presets: [
        {
          name: 'default',
          label: $filter('translate')('services.campaignElementCreator.default'),
          template_type: 'zcs_textonly',
          img_url: '',
          element: _.merge(defaultMessage, {
            // Allowed properties:
            // ==================
            // show_modal_first
            // offer_template
            // zc_header
            // zc_insentive_requirement
            // zc_insentive_value
            // zc_insentive_usage_requirement
            // code_title
            // code_name
            // code_condition
            // code_description
            // present_pagetype
            // base_color
            // second_color
            // enables_timer
            // limit
            // enables_badge
            // badge_position
            // badge_icon
            // offer_hint
            // present_hint
            // btntext_offer
            // linkage_url_offer
            // remove_target_blank
            // btntext_present
            // linkage_url
            // remove_target_blank_present
            // code_autoinput
            // reject_pagetypes
            // ignore_pagetype
            // reject_cbc

            second_color: '#F1B33B',
            code_name: $filter('translate')('services.campaignElementCreator.code'),
            zc_header: $filter('translate')('services.campaignElementCreator.customerNotice'),
            zc_insentive_requirement: '',
            zc_insentive_value: '',
            zc_insentive_usage_requirement: '',
            offer_template: 'pattern3',
            present_hint: `${$filter('translate')('services.campaignElementCreator.presentHint1')}<br>
                          ${$filter('translate')('services.campaignElementCreator.presentHint2')}<br>
                          ${$filter('translate')('services.campaignElementCreator.presentHint3')}`
          })
        },
      ]
    },

    {
      template_type: 'zcs_image',
      label: $filter('translate')('services.campaignElementCreator.imageTemplate'),
      img_url: '/assets/img/icon-lg-coupon-image.svg',
      presets: [
        {
          name: 'default',
          label: $filter('translate')('services.campaignElementCreator.default'),
          template_type: 'zcs_image',
          img_url: '',
          element: _.merge(defaultMessage, {
            // Allowed properties:
            // ==================
            // show_modal_first
            // banner
            // code_title
            // code_name
            // code_condition
            // code_description
            // present_pagetype
            // base_color
            // limit
            // badge_position
            // badge_icon_font
            // offer_hint
            // present_hint
            // btntext_offer
            // linkage_url_offer
            // remove_target_blank
            // btntext_present
            // linkage_url
            // remove_target_blank_present
            // code_autoinput
            // reject_pagetypes
            // ignore_pagetype
            // reject_cbc
            // howtouse_text

            banner: '',
            second_color: '#F76065',
          })
        }

      ]
    }
  ];
  // for caching template request values
  let allTemplates;

  return service;


  function createCampaignElement(campaign, project, selectedTemplate) {
    if(!_.get(campaign, 'element.message')) {
      if(!campaign.element) {
        campaign.element = {};
      }
      campaign.element.message = {};
    }

    if(!allTemplates) {
      Template.all(project.id).then(res => {
        allTemplates = res;
        selectTemplate(selectedTemplate, campaign, project);
      });
    } else {
      selectTemplate(selectedTemplate, campaign, project);
    }
  }


  function selectTemplate(selectedTemplate, campaign, project) {
    // if selectedTemplate is null, use the first one
    if(!selectedTemplate) selectedTemplate = basicSelectableTemplates[0];

    campaign.selectedTemplate = selectedTemplate;
    campaign.template_type = selectedTemplate.template_type;

    const template = _.find(allTemplates, d => d.name === campaign.template_type);

    if(template) {
      campaign.campaign_type = template.campaign_type;
      _.each(template.template, element => {
        if(element.type === 'number') {
          campaign.element.message[element.name] = 0;
          if(element.default) {
            campaign.element.message[element.name] = element.default;
          }
        } else {
          campaign.element.message[element.name] = '';
          if(element.default) {
            campaign.element.message[element.name] = $filter('translate')(element.default);
          }
        }
      });
    }

    // TODO: support for multiple presets
    campaign.element.message = _.merge(campaign.element.message, selectedTemplate.element);
    setDefaultMessageValues(campaign, project);
  }


  /* sets only the text values! */
  function setDefaultMessageValues(campaign, project, isUpdateCodeTitleOnly = false) {
    const incentive = _.get(campaign, 'incentives[0]') || campaign.incentive_draft;
    // if(!incentive) {
    // TODO: would like to throw error but it is thrown every time on reload on every page expect segment so...
    //  throw new Error(`Unknown incentive type on ${project.apikey} - discount_type: ${incentive.discount_type}, is_free_shipping ${incentive.is_free_shipping} `);
    // }

    if(campaign.template_type === 'giftcard') {
      setGiftCardTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly);
    } else {
      setLegacyTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly);
    }
  }


  function setLegacyTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly) {
    campaign.element.message.code_title = getCodeTitle(
      project,
      campaign,
      incentive,
      /* isLegacy = */ true,
      /* useLineBreak = */ true,
      /* useExclamationMark = */ false,
    );
    campaign.element.message.discount_type = getDiscountType(incentive.discount_type, project);
    campaign.element.message.discount_value = getDiscountValue(incentive);

    if(campaign.template_type === 'zcs_textonly') {
      campaign.element.message.zc_insentive_value = getCodeTitle(
        project,
        campaign,
        incentive,
        /* isLegacy = */ true,
        /* useLineBreak = */ false,
        /* useExclamationMark = */ true,
      );
      campaign.element.message.zc_insentive_requirement = $filter('translate')('services.campaignElementCreator.incentiveRequirement', { limit: campaign.element.message.limit - 1 });
    } else {
      campaign.element.message.zc_insentive_value = undefined;
      campaign.element.message.zc_insentive_requirement = undefined;
      campaign.element.message.zc_insentive_usage_requirement = undefined;
    }

    if(isUpdateCodeTitleOnly) {
      return;
    }

    setLegacyInsentiveUsageRequirement(campaign, project, incentive);
    setLegacyCodeDescription(campaign, project);
    setCodeCondition(campaign, project, incentive, true);
  }


  function setLegacyCodeDescription(campaign, project) {
    const firstLine = `<strong>${$filter('translate')('services.campaignElementCreator.howToUseCoupon')}</strong>`;

    if(project.shopping_cart_asp === 'shopserve') {
      campaign.element.message.code_description = [
        firstLine,
        $filter('translate')('services.campaignElementCreator.couponUsage1'),
        $filter('translate')('services.campaignElementCreator.couponUsage2'),
      ].join('\n');
      return;
    }

    campaign.element.message.code_description = [
      firstLine,
      `${$filter('translate')('services.campaignElementCreator.codeDescription1')}<br>`,
      `${$filter('translate')('services.campaignElementCreator.codeDescription2')}<br>`,
      $filter('translate')('services.campaignElementCreator.codeDescription3'),
    ].join('\n');
  }

  // For zcs_textonly template only
  function setLegacyInsentiveUsageRequirement(campaign, project, incentive) {
    const currency = currencies[project.currency];
    if(campaign.template_type !== 'zcs_textonly') {
      return;
    }

    if(project.shopping_cart_asp !== 'makeshop') {
      campaign.element.message.zc_insentive_usage_requirement = `${$filter('translate')('services.campaignElementCreator.limitedToOnePersone')}<br>`;
    }

    if(incentive && incentive.minimum_price) {
      campaign.element.message.zc_insentive_usage_requirement += `\n${$filter('translate')('services.campaignElementCreator.incentiveUsageRequirement', { amount: `${currency.symbol}${incentive.minimum_price}${currency.suffix}` })}`;
    }
  }


  function setGiftCardTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly = true) {
    campaign.element.message.code_title = getCodeTitle(project, campaign, incentive);
    campaign.element.message.discount_type = getDiscountType(incentive.discount_type, project);
    campaign.element.message.discount_value = getDiscountValue(incentive);
    if(isUpdateCodeTitleOnly) {
      return;
    }
    setCodeCondition(campaign, project, incentive);
    setCodeDescription(campaign, project);
  }


  function setCodeCondition(campaign, project, incentive, isLegacy) {
    const currency = currencies[project.currency];
    campaign.element.message.code_condition = '';

    if(project.shopping_cart_asp !== 'makeshop') {
      campaign.element.message.code_condition = `${$filter('translate')('services.campaignElementCreator.limitedToOnePersone')}<br>`;
    }

    if(incentive && incentive.minimum_price) {
      campaign.element.message.code_condition += `\n${$filter('translate')('services.campaignElementCreator.minimumPrice', { amount: `${currency.symbol}${incentive.minimum_price}${currency.suffix}` })}`;

      if(isLegacy) {
        campaign.element.message.code_condition = $filter('translate')('services.campaignElementCreator.codeCondition', { amount: `${currency.symbol}${incentive.minimum_price}${currency.suffix}` });
      }

      if(!incentive.has_price_limit) {
        campaign.element.message.code_condition = '';
      }
    }
  }


  function setCodeDescription(campaign, project) {
    const firstLine = project.shopping_cart_asp === 'makeshop'
      ? `<li>${$filter('translate')('services.campaignElementCreator.codeDescriptionAddress')}</li>`
      : `<li>${$filter('translate')('services.campaignElementCreator.codeDescriptionOrder')}</li>`;

    campaign.element.message.code_description = [
      firstLine,
      `<li>${$filter('translate')('services.campaignElementCreator.pasteCode')}</li>`,
    ].join('\n');
  }


  function getDiscountType(type, project) {
    const currency = currencies[project.currency];
    const discountTypes = {
      price: `${currency.symbol}${currency.suffix}`,
      percent: '%',
    };

    return _.get(discountTypes, type, 'free_shipping');
  }


  function getDiscountValue(incentive) {
    const discountValues = {
      price: incentive.discount_price,
      percent: incentive.discount_percent,
    };

    return _.get(discountValues, incentive.discount_type, '');
  }


  function getCodeTitle(project, campaign, incentive, isLegacy = false, useLineBreak = false, useExclamationMark = false) {
    const span = {
      open: isLegacy ? '<span>' : '',
      close: isLegacy ? '</span>' : '',
    };

    const exclamationMark = useExclamationMark ? '!' : '';

    if(!incentive) {
      return $filter('translate')('services.campaignElementCreator.incentive');
    }

    if(incentive.is_free_shipping) {
      const lineBreak = useLineBreak ? '<br>' : '';
      return `${span.open}${$filter('translate')('services.campaignElementCreator.freeShipping')}${span.close}${lineBreak}${$filter('translate')('services.campaignElementCreator.couponPresent')}${exclamationMark}`;
    }

    return [
      span.open,
      getDiscountValue(incentive),
      getDiscountType(incentive.discount_type, project),
      ' OFF',
      span.close,
      $filter('translate')('services.campaignElementCreator.couponPresent'),
      exclamationMark,
    ].join('');
  }


  function getSelectableTemplates(project) {
    if(project.region !== 'asia_tokyo') {
      const textTemplate = _.findIndex(basicSelectableTemplates, { template_type: 'zcs_textonly' });
      if(textTemplate >= 0) {
        basicSelectableTemplates.splice(textTemplate, 1);
      }
    }
    return basicSelectableTemplates;
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/campaign_element_creator.service.js